<template>
  <div class="tw:flexrow-1 tw:items-center tw:justify-between">
    <div class="tw:flexrow-1 tw:items-center tw:min-w-0">
      <v-checkbox
        :input-value="metadata.isVisible"
        hide-details
        :ripple="false"
        class="tw:m-0 tw:p-0 tw:[&_.v-input--selection-controls\_\_input]:m-0"
        @change="toggleVisibility"
      ></v-checkbox>
      <div>
        <layer-style-preview-icon v-bind="layerIconBind" />
      </div>
      <div class="tw:text-sm tw:truncate">{{ metadata.name }}</div>
    </div>
    <div class="tw:flexrow-0">
      <base-button
        v-for="action in actions"
        :key="action.name"
        type="text"
        :tooltip="action.tooltip || null"
        :icon="action.icon"
        @click="handleAction(action.name)"
      />
      <dots-menu :items="[{ name: 'delete' }]" @delete="removeLayer" />
    </div>
  </div>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
import LayerStylePreviewIcon from '@/components/LayerStylePreviewIcon';

export default {
  name: 'TemporaryLayersListItem',
  components: {
    DotsMenu,
    LayerStylePreviewIcon,
  },
  props: {
    metadata: {
      type: Object,
      required: true,
    },
  },
  computed: {
    actions() {
      return [
        {
          name: 'zoom',
          icon: 'mdi-fullscreen',
          tooltip: this.$i18n.t('button.zoomToLayer'),
        },
      ];
    },
    layerIconBind() {
      return {
        layerType: this.metadata.geometry_type,
        layerStyle: this.metadata.style,
        isIcon: true,
        hideColorPicker: true,
      };
    },
  },
  methods: {
    handleAction(name) {
      switch (name) {
        case 'zoom':
          return this.zoomToLayer();
        default:
          throw new Error(`Action ${name} not recognized`);
      }
    },
    zoomToLayer() {
      this.$root.$emit('zoomToCustomLayer', this.metadata.id, 'temporaryLayers');
    },
    removeLayer() {
      this.$root.$emit('removeTemporaryLayer', this.metadata.id);
    },
    toggleVisibility(e) {
      this.$root.$emit('alterTemporaryLayer', this.metadata.id, 'visibility', e);
    },
  },
};
</script>
